@for (data of dataCollaborator; track data; let i = $index) {
  <div class="notes pl-1 pr-1 pt-1">
    <div class="notes-item">
      <div class="notes-users">
        <ul class="list-unstyled users-list cursor-pointer m-0 d-flex align-items-center">
          <li class="avatar pull-up my-0 " triggers="click" placement="left" [ngbTooltip]="data.name">
            <app-avatar-photo [photoUrl]="undefined" [name]="data.name"></app-avatar-photo>
          </li>
          <div class="ml-2" style="width: 200px;">
            <div>{{data?.name}}</div>
            <div class="notes-footer-left d-flex align-items-center ">
              <div class="notes-due-date mr-4">
                <span class="font-size-small">{{data.email}}</span>
                <div class="d-flex align-items-center mt-1">
                  <span class="font-size-small mr-2">{{ data?.suscription_date | date:'MMM d, y h:mm a':'':'en-US' }}</span>
                </div>
              </div>
            </div>
          </div>
          <ng-template #start>
            <header class="text-title mt-1">
              <span>Motivo o razón</span>
              <hr>
              </header>
              <main class="text-subtitle text-left">{{data.reason? data.reason : 'No indica'}}</main>
            </ng-template>
            <div class="mr-2" [id]="'info-'+i" [ngbTooltip]="start" triggers="click:blur">
              <a>
                <i class="fa fa-info-circle"></i>
              </a>
            </div>
            @if (isOwner || isCreator) {
              <div class="md-1">
                <a (click)="openModalToDeleteCollaborator(data.id)" style="color: red;">
                  <i class="far fa-trash-alt"></i>
                </a>
              </div>
            }
          </ul>
        </div>
      </div>
    </div>
  }